export default __webpack_public_path__ + "static/media/avatarC8.6d045f90.png";